import { Panel } from "primereact/panel"
import { DeclaracionCpn } from "../../../models/cpn/DeclaracionCpn"
import { useForm } from "react-hook-form";
import * as generic from '../../../components/Generico';
import { InputComponent } from "../../../components/InputComponent";
import { ClientePNService } from "../../../service/ClientePNService";
import { useEffect, useState } from "react";
import { FileComponent } from "../../../components/FileComponent";
import { AnexosComponent } from "../../../components/AnexosComponent";
import { Dialog } from "primereact/dialog";
import { VisorPdf } from "../../../components/VisorPdf";
import { ProgressSpinner } from "primereact/progressspinner";
import { Inmueble } from "../common/Inmueble";
import { BottomActionBar } from "../../../components/ui/BottomActionBar";

export const DeclaracionPn = ({ id, toast, seccion, permss, setdialogIns, urls, estado, reiniciar, catalogos, soloLectura, back }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new DeclaracionCpn();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues });
    const { inArea, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const clientepnSrv = new ClientePNService();
    const [loadReport, setLoadReport] = useState(false);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const [dialogVisor, setDialogVisor] = useState(false);
    const [pdfUrl, setPdfUrl] = useState({ url: null, name: '' });
    const { enviarFormulario } = FileComponent({ tipo: 'clientePn', toast, unuevo: 'ficha/clientepn/store', udelete: 'ficha/clientepn/eliminar-anexo', permss, id });
    const [firmaActiva, setFirmaActiva] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const esDifare = catalogos?.tipoFrmEmpresa === 'FRM_DIFARE';

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        data.seccion = seccion;
        data.id = id;
        setIsSaving(true);
        clientepnSrv.editarClientepn(data).then(res => {
            setdialogIns(true);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id, seccion).then(res => {
            const _clientepn = res.data.clientepn;
            if (res.data.firmaActiva) {
                setFirmaActiva(res.data.firmaActiva);
            }
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    // mostrarVisor=true abre el PDF en el visor; false lo descarga directo al navegador
    const ejecutarDescarga = (firmar, estadoParam, fileName, mostrarVisor) => {
        setLoadReport(true);
        clientepnSrv.descargar(id, firmar, estadoParam, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            if (mostrarVisor) {
                const blob = new Blob([res], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(blob);
                setPdfUrl({ url: fileURL, name: fileName });
                setDialogVisor(true);
            } else {
                generic.downloadPdf(res, fileName);
            }
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    };

    const descargarDocumento = (firmar = false) => {
        // Si firmar es false y estado es "ENVIADO" recuperará el archivo subido formulario principal
        // Solo entra a esta función si el estado es "ENVIADO"
        ejecutarDescarga(firmar, estado, `${id}-Formulario-cliente-PN-firmado.pdf`, true);
    };

    const generarReporte = (firmar = false) => {
        if (!firmaActiva) {
            // Firma desactivada: descarga sin visor
            // Al no enviar el estado se genera un nuevo reporte
            ejecutarDescarga(firmar, undefined, `${id}-Formulario-cliente-PN.pdf`, false);
            return;
        }

        // Firma activada: si está enviado, descargar anexo firmado
        if (estado === "ENVIADO") {
            descargarDocumento(false);
            return;
        }

        // Firma activa y borrador: generar PDF y mostrar en visor
        // No es necesario pasar el estado pues no hay condicion para descarga normal
        ejecutarDescarga(firmar, undefined, `${id}-Formulario-cliente-PN.pdf`, true);
    }

    const subirReporte = () => {
        setDialogAnexos(true);
    }

    const enviar = (opcion = null) => {
        enviarFormulario(id, `ficha/clientepn/enviar?tipoFrmEmpresa=${catalogos?.tipoFrmEmpresa ?? ''}`, 'clientePn', opcion);
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="fadein animation-duration-300">
            {esDifare && (
                <Panel header={generic.renderPanelHeader('C.2', 'DATOS DE LA VIVIENDA / DEPARTAMENTO /OFICINA', 'pi pi-home')} className="panel-ficha shadow-1 mb-4">
                    <div className="col-12 px-0 mb-0">
                        <Inmueble tipo="clientePn" id={id} toast={toast} permss={permss} num={11} soloLectura={soloLectura} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} />
                    </div>
                </Panel>
            )}
            <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('D.1', 'DECLARACIÓN DE ORIGEN LÍCITO DE FONDOS', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Términos de la Declaración</span>
                        </div>
                        {omodel.strDeclara}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('D.2', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {!esTipoEspecial && omodel.strAutorizacionTratamientoDatos}
                        {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && omodel.strToyota}
                        {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                    </div>
                </Panel>

                {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && (
                    <Panel header={generic.renderPanelHeader('', 'CONSENTIMIENTO PARA EL USO DE DATOS PERSONALES', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid align-items-center">
                            <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                                {omodel.strConceder}
                            </div>
                            {inDrop('uso_dato_personal', generic.estadosSiNo, { lab: 'nombre' }, 4)}

                            <div className="field col-8 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                                {omodel.strActividad}
                            </div>
                        </div>
                    </Panel>
                )}

                {!esTipoEspecial && (
                    <Panel header={generic.renderPanelHeader('', 'OBSERVACIONES', 'pi pi-comment')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid p-2">
                            {inArea('observacion', 5, 9000, 12)}
                        </div>
                    </Panel>
                )}

                <Panel header={generic.renderPanelHeader('', 'ANEXOS', 'pi pi-paperclip')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        <div className="field col-12 md:col-6 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500 mb-3 md:mb-0">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">CLIENTE QUE TRABAJA EN RELACIÓN DE DEPENDENCIA</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {catalogos?.anexosRequisitosDep?.map((req, index) => (
                                    <li key={index} className="mb-2">{req}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="field col-12 md:col-6 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500 mb-0">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">CLIENTE QUE TRABAJA SIN RELACIÓN DE DEPENDENCIA O INDEPENDIENTE</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {catalogos?.anexosRequisitosInd?.map((req, index) => (
                                    <li key={index} className="mb-2">{req}</li>
                                ))}
                            </ul>
                        </div>

                        {['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa) && (
                            <div className="field col-12 p-3 mt-4 text-justify font-bold line-height-3 text-xs bg-yellow-50 border-round border-left-3 border-yellow-500 mb-0">
                                {omodel.msgAnexo}
                            </div>
                        )}
                    </div>
                </Panel>

                <BottomActionBar
                    onPrev={back}
                    onSave={true}
                    onGenerate={() => generarReporte(false)}
                    onSend={() => enviar()}
                    onAttachments={subirReporte}
                    loading={loadReport || isSaving}
                    isReadOnly={soloLectura}
                    enableExtras={id != null}
                />
            </form>

            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="clientePn" urls={urls} idp={id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} estado={estado} soloLectura={soloLectura} />
            </Dialog>

            <VisorPdf visible={dialogVisor} onHide={() => setDialogVisor(false)} fileBlobUrl={pdfUrl.url} fileName={pdfUrl.name} firmar={() => descargarDocumento(true)} firmarEnviar={() => enviar('firmarEnviar')} id={id} tipo='clientePn' urls={urls} toast={toast} />
        </div>
    )
}
